// extracted by mini-css-extract-plugin
module.exports = {"grid":"ShelterPage_grid__MA2ra","gridItem":"ShelterPage_gridItem__3xfsC"};